module.exports = __webpack_public_path__ + "static/img/screenshot-create-listing.7a95b10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshot-create-listing.jpg
// module id = 4hi9
// module chunks = 1